import { render } from "./RequestFormComponent.vue?vue&type=template&id=b27f345c&scoped=true"
import script from "./RequestFormComponent.vue?vue&type=script&lang=js"
export * from "./RequestFormComponent.vue?vue&type=script&lang=js"

import "./RequestFormComponent.vue?vue&type=style&index=0&id=b27f345c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b27f345c"]])

export default __exports__